// 원국에서 나오는 장면 소품. 소품 선택 규칙은 게임 규칙이며 고서의 근거가 없다.
// - 일간 오행의 소품: elementProps[오행] 3개 중 일지 번호 % 3 번째 1개 (link-map.json 의 오행별 소품)
// - 막 소품: 서사 축 데이터의 현재 막 props 첫 번째 (축 내용이 없는 격국은 없음)
// 조후 소품(johuProps)은 조후 필요 오행이 게임 추정이라 쓰지 않는다.
import { ARC_DATA } from './arcData.js';
import { actOf } from './arc.js';
import { essenceOf } from './essence.js';

const STEM_ELEMENT = ['목', '목', '화', '화', '토', '토', '금', '금', '수', '수'];

/** { element: { label, el }, act: { label, act } | null } — 일간을 모르면 null. */
export function natalProps(run) {
  const dayStem = run?.saju?.day?.stem, dayBranch = run?.saju?.day?.branch;
  if (!Number.isInteger(dayStem) || !Number.isInteger(dayBranch)) return null;
  const el = STEM_ELEMENT[dayStem];
  const list = ARC_DATA.elementProps?.[el];
  if (!list?.length) return null;
  const element = { el, label: list[dayBranch % list.length] };

  const arcId = essenceOf(run.saju)?.arcId?.value;
  const act = actOf(run.age) ?? 1;
  const actData = arcId ? ARC_DATA.arcs[arcId]?.acts.find((a) => a.act === act) : null;
  return { element, act: actData?.props?.[0] ? { label: actData.props[0], act } : null };
}

// 소품 이름을 그림 분류로 묶는다. 개별 소품 그림이 아니라 다섯 가지 공통 도형이다.
const CATEGORY_WORDS = [
  ['plant', ['화분']],
  ['lamp', ['스탠드', '촛대']],
  ['vessel', ['컵', '병', '주전자', '잔']],
  ['paper', ['종이', '노트', '서류', '문서', '장부', '원고', '명부', '표', '합의서', '의뢰서', '철']],
];
export function propCategory(label) {
  const text = String(label ?? '');
  for (const [category, words] of CATEGORY_WORDS) if (words.some((word) => text.includes(word))) return category;
  return 'tool';
}
